// src/pages/UploadVideo.js  (ou le chemin que tu utilises)
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "./UploadVideo.scss";
import {
    uploadVideo
} from '../services/apiContent';
import { fetchUsersByCategorie } from "../services/apiUsers";

export default function UploadVideo() {

const [categorieId, setCategorieId] = useState("");
const [users, setUsers] = useState([]);

  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [userId, setuserId] = useState("");
  
  const [isDragActive, setIsDragActive] = useState(false);
  
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [previewImage1, setPreviewImage1] = useState(null);
  const [previewImage2, setPreviewImage2] = useState(null);

  const inputRef = useRef(null);

  useEffect(() => {
    // Nettoyage de l'objectURL quand le composant est démonté ou que le fichier change
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);
  
  useEffect(() => {
  
    (async () => {
      const data = await fetchUsersByCategorie(1);
      setUsers(data);
    })();
  }, []);

  
  const handleImageSelect = (e, setImage, setPreview) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // --- handlers et upload corrigés ---
const handleFile = (selectedFile) => {
    if (!selectedFile) return;
    if (!selectedFile.type.startsWith("video/")) {
      alert("Veuillez déposer un fichier vidéo.");
      return;
    }
  
    // libère l'ancien objectURL si nécessaire
    if (previewUrl) {
      try { URL.revokeObjectURL(previewUrl); } catch (e) {}
    }
  
    setFile(selectedFile); // Assure-toi que l'état s'appelle bien `file`
    setPreviewUrl(URL.createObjectURL(selectedFile));
  };
  
  const handleFileChange = (e) => {
    const selectedFile = e.target.files && e.target.files[0];
    handleFile(selectedFile);
  };
  
  // Drag & Drop : empêche le comportement par défaut (ouvrir le fichier)
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  };
  
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // indique visuellement l'action possible
    e.dataTransfer.dropEffect = "copy";
    setIsDragActive(true);
  };
  
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  
    const dt = e.dataTransfer;
    if (!dt) return;
  
    const dropped = dt.files && dt.files[0];
    if (!dropped) return;
  
    handleFile(dropped);
  
    // clear DataTransfer si possible
    try {
      dt.clearData();
    } catch (err) {}
  };
  
  // --- handleUpload corrigé : vérifie que FormData contient bien un File puis appelle uploadVideo ---
  const handleUpload = async () => {
    if (!file) {
      alert("Veuillez sélectionner une vidéo !");
      return;
    }
  
    setIsUploading(true);
    setMessage("");
    setUploadProgress(0);
  
    const formData = new FormData();
    formData.append("video", file);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("type", "film");
    formData.append("categorie_id", "1");
    formData.append("video_img_1", image1);
    formData.append("video_img_2", image2);
    formData.append("user_id", userId);

    console.log("🖼️ image1:", formData.get("video_img_1")?.name, formData.get("video_img_1") instanceof File);
    console.log("🖼️ image2:", formData.get("video_img_2")?.name, formData.get("video_img_2") instanceof File);
  
  
    // Vérification explicite avant envoi (utile pour debug)
    const videoEntry = formData.get("video");
    if (!(videoEntry instanceof File)) {
      console.error("Le champ 'video' dans FormData n'est pas un File :", videoEntry);
      setMessage("Le fichier vidéo n'a pas été ajouté correctement.");
      setIsUploading(false);
      return;
    }
  
    try {
      // si uploadVideo est la fonction de ton service qui utilise axios et accepte onUploadProgress
      const res = await uploadVideo(formData, (progressEvent) => {
        if (progressEvent && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        }
      });
  
      setMessage("✅ Vidéo uploadée avec succès !");
      console.log("Upload response:", res?.data ?? res);
      
    // 🔄 Réinitialiser le formulaire après succès
    setFile(null);
    setTitle("");
    setDescription("");
    setPreviewUrl(null);
    setUploadProgress(0);
    setImage1(null);
    setImage2(null);
    setPreviewImage1(null);
    setPreviewImage2(null);
    setuserId("");

    // Si tu as un inputRef pour le champ fichier :
    if (inputRef.current) {
      inputRef.current.value = ""; // réinitialise le champ file
    }

    } catch (err) {
      console.error("Erreur upload :", err);
      setMessage("❌ Erreur lors de l’upload.");
    } finally {
      setIsUploading(false);
    }
  };
  
  return (
    <div className="page-content">
    <h1 className="upload-title">Téléverser une vidéo</h1>
      {/* Tabs */}
      <div className="tabs">
        <button className="tab active">Films</button>
        <button className="tab">Series</button>
        <button className="tab">Documentaires</button>
      </div>
        <div className="upload-page">
        <div className="upload-card">
            <h1 className="upload-title">Ajouter un film</h1>
            


            {/* Zone d’aperçu ou d’import avec drag & drop */}
            <div
            className={
                "upload-dropzone" + (isDragActive ? " upload-dropzone--active" : "")
            }
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            // pour que les événements fonctionnent aussi si l'utilisateur drop via un enfant
            role="button"
            >
            {previewUrl ? (
                <video src={previewUrl} controls className="upload-preview" />
            ) : (
                <div className="upload-placeholder">
                <p>Glissez votre fichier ici ou cliquez ci-dessous</p>
                </div>
            )}

            {/* input caché visuellement mais accessible au clic */}
            <input
                ref={inputRef}
                type="file"
                accept="video/*"
                onChange={handleFileChange}
                className="upload-input"
            />

            {/* petit texte/cliquable pour déclencher l'input (utile pour UX) */}
            <div
                className="upload-click-here"
                onClick={() => {
                if (inputRef.current) inputRef.current.click();
                }}
                onKeyDown={(e) => {
                if (e.key === "Enter" && inputRef.current) inputRef.current.click();
                }}
                tabIndex={0}
                role="button"
                aria-label="Choisir un fichier"
            >
                <button type="button" className="upload-choose-btn">
                Choisir un fichier
                </button>
            </div>
            </div>

            {/* Barre de progression */}
            {isUploading && (
            <div className="upload-progress">
                <div
                className="upload-progress-bar"
                style={{ width: `${uploadProgress}%` }}
                ></div>
                <p>{uploadProgress}%</p>
            </div>
            )}

            {/* Miniatures */}
            <div className="upload-images">
                <div className="upload-image-field">
                    <p className="upload-label">Image principale</p>
                    <div className="upload-box">
                    {previewImage1 ? (
                        <img src={previewImage1} alt="preview1" className="upload-thumb" />
                    ) : (
                        <div className="upload-placeholder">
                        <span>Glissez ou sélectionnez une image</span>
                        </div>
                    )}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageSelect(e, setImage1, setPreviewImage1)}
                        className="upload-input"
                    />
                    </div>
                </div>

                <div className="upload-image-field">
                    <p className="upload-label">Image Secondaire</p>
                    <div className="upload-box">
                    {previewImage2 ? (
                        <img src={previewImage2} alt="preview2" className="upload-thumb" />
                    ) : (
                        <div className="upload-placeholder">
                        <span>Glissez ou sélectionnez une image</span>
                        </div>
                    )}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageSelect(e, setImage2, setPreviewImage2)}
                        className="upload-input"
                    />
                    </div>
                </div>
            </div>


            {/* Métadonnées */}
            <div className="upload-form">
            <input
                type="text"
                placeholder="Titre de la vidéo"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />
            <textarea
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
            ></textarea>
            
              {/* Sélection utilisateur */}
              <select
                value={userId}
                onChange={(e) => setuserId(e.target.value)}
                disabled={!users.length}
              >
                <option value="">
                  {users.length ? "Sélectionner un utilisateur" : "Aucun utilisateur"}
                </option>

                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.nom} — {user.phone}
                  </option>
                ))}
              </select>
            </div>

            {/* Bouton publier */}
            <div className="upload-actions">
            <button onClick={handleUpload} disabled={isUploading}>
                {isUploading ? "Chargement..." : "Publier"}
            </button>
            </div>

            {message && <p className="upload-message">{message}</p>}
        </div>
        </div>

    </div>
  );
}
